<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Transactions</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Transactions
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="card card-style">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-6 col-xl-6 col-sm-12 col-6">
                                <div
                                    style="
                                        display: flex;
                                        justify-items: baseline;
                                        align-items: center;
                                        width: 300px;
                                        padding-bottom: 6px;
                                    "
                                >
                                    <i
                                        class="fa fa-money customize-icon font-large-1 mr-1"
                                    ></i>
                                    <h1
                                        style="
                                            font-size: 20px;
                                            font-weight: bold;
                                        "
                                    >
                                        Total Revenue
                                    </h1>
                                </div>

                                <h3>{{ total_revenue }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card card-style">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-6 col-xl-6 col-sm-12 col-6">
                                <div
                                    style="
                                        display: flex;
                                        justify-items: baseline;
                                        align-items: center;
                                        width: 300px;
                                        padding-bottom: 6px;
                                    "
                                >
                                    <i
                                        class="icon icon-bar-chart customize-icon font-large-1 mr-1"
                                    ></i>
                                    <h1
                                        style="
                                            font-size: 20px;
                                            font-weight: bold;
                                        "
                                    >
                                        Total Transactions Today
                                    </h1>
                                </div>

                                <h3>{{ `${total_transactions_today} (${total_transactions_today_count})` }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card card-style">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-6 col-xl-6 col-sm-12 col-6">
                                <div
                                    style="
                                        display: flex;
                                        justify-items: baseline;
                                        align-items: center;
                                        width: 300px;
                                        padding-bottom: 6px;
                                    "
                                >
                                    <i
                                        class="fa fa-money customize-icon font-large-1 mr-1"
                                    ></i>
                                    <h1
                                        style="
                                            font-size: 20px;
                                            font-weight: bold;
                                        "
                                    >
                                        Total Payouts
                                    </h1>
                                </div>
                                <h3>{{ total_payouts }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card card-style">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-6 col-xl-6 col-sm-12 col-6">
                                <div
                                    style="
                                        display: flex;
                                        justify-items: baseline;
                                        align-items: center;
                                        width: 300px;
                                        padding-bottom: 6px;
                                    "
                                >
                                    <i
                                        class="icon icon-bar-chart customize-icon font-large-1 mr-1"
                                    ></i>
                                    <h1
                                        style="
                                            font-size: 20px;
                                            font-weight: bold;
                                        "
                                    >
                                        Total Payouts Today
                                    </h1>
                                </div>

                                <h3>{{ `${total_payouts_today} (${total_payouts_today_count})` }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>All Transactions</h4>
                </div>

                <div class="card-body">
                    <div class="search-container pb-2">
                        <form @submit.prevent="paginatedData">
                            <div class="row">
                                <div class="col-md-3 d-flex align-items-center">
                                    <input id="search-term" type="text"
                                           class="table-search form-control form-control-sm"
                                           placeholder="🔎 Search this table (Ref, Amount, Name, Email, Phone)"
                                           v-model="searchTerm"
                                           @keyup="paginatedData"
                                    >
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Payment Method</label><br/>
                                        <select class="form-control form-control-sm" v-model="filter.payment_method">
                                            <option value="">All</option>
                                            <option v-for="payment_method in payment_methods" :value="payment_method.value">{{ payment_method.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>User Type</label><br/>
                                        <select class="form-control form-control-sm" v-model="filter.user_type">
                                            <option value="">All</option>
                                            <option value="Passenger">Users</option>
                                            <option value="Driver">Drivers</option>
                                            <option value="FleetManager">Fleet Managers</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Status</label><br/>
                                        <select class="form-control form-control-sm" v-model="filter.status">
                                            <option value="">All</option>
                                            <option value="0">Pending</option>
                                            <option value="1">Successful</option>
                                            <option value="2">Failed</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Start Date</label><br/>
                                        <input type="date" class="form-control form-control-sm" v-model="filter.start_date">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>End Date</label><br/>
                                        <input type="date" class="form-control form-control-sm" v-model="filter.end_date">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>&nbsp;</label><br/>
                                        <button type="submit" class="btn btn-sm btn-primary glow mb-1 mb-sm-0" :disabled="isLoadingFilter">
                                            Apply Filter
                                            <i class="fa fa-spinner spinner" v-if="isLoadingFilter"></i>
                                        </button>
                                        <button type="reset" @click="resetFilter" class="btn btn-sm btn-warning glow mb-1 mb-sm-0">
                                            Reset Filter
                                        </button>
                                    </div>
                                </div>


                                <!--                            <div class="col-lg-3 col-md-4 col-sm-6 d-flex">-->
                                <!--                                <download-excel type="csv" :data="admins" :export-fields="exportFields">-->
                                <!--                                    <a href="#" class="export-link"><i class="fas fa-file-csv"></i> export to csv</a>-->
                                <!--                                    | &nbsp;-->
                                <!--                                </download-excel>-->
                                <!--                                <download-excel :data="admins" :fields="exportFields">-->
                                <!--                                    <a href="#" class="export-link text-warning"><i class="fa fa-file-excel-o"></i>-->
                                <!--                                        export to excel-->
                                <!--                                    </a>-->
                                <!--                                </download-excel>-->
                                <!--                            </div>-->
                            </div>
                        </form>
                    </div>

                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allTransactions"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>

                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>

                            <span v-else-if="props.column.field === 'status'" :class="'badge-glow badge badge-' + transactionStatus(props.row.readable_status)">
                                {{ props.row.readable_status }}
                            </span>
                            <span v-else-if="props.column.field === 'type'" :class="'badge ' + statusClass(props.row.type === 'credit')">
                                {{ props.row.type }}
                            </span>
                            <span v-else-if="props.column.field === 'created_at'">
                                {{ formatDateShort(props.row.created_at) }}
                            </span>
<!--                            <span >-->
<!--                               <a :href="route('admin.trips.show', props.row.id)">{{-->
<!--                                       props.row.first_name + ' ' + props.row.last_name-->
<!--                                   }}</a>-->
<!--                            </span>-->
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
    metaInfo: {title: 'Transactions'},
    props: [
        'transactions',
        'total_revenue',
        'total_transactions_today_count',
        'total_transactions_today',
        'total_payouts_count',
        'total_payouts',
        'total_payouts_today_count',
        'total_payouts_today',
        'payment_methods'
    ],
    name: "TransactionIndex",
    layout: Layout,

    data: () => ({
        filter: {
            payment_method : '',
            status : '',
            user_type : '',
            start_date: '',
            end_date: ''
        },
        isLoadingFilter: false,
        allTransactions: [],
        searchTransaction:{},
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},

            {label: 'Type', field: 'type'},
            {label: 'Reference', field: 'transaction_no'},
            {label: 'Amount', field: 'amount'},
            {label: 'Payment Method', field: 'payment_method'},
            {label: 'User', field: 'user.full_name'},
            {label: 'User Type', field: 'user_type'},
            {label: 'Date', field: 'created_at'},
            {label: 'Status', field: 'status'},
            // {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
        searchTerm: '',
    }),
    created() {
        this.allTransactions = this.transactions.data
        this.totalRecords = this.transactions.total
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.paginatedData();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.paginatedData();
        },
        onSortChange(params) {
            this.serverParams.sort = {
                type: params[0].type,
                field: params[0].field,
            }
            this.paginatedData();
        },
        async paginatedData() {
            try {
                let url = route('admin.transactions.index') +
                    `?q=${this.searchTerm}&page=${this.serverParams.page}&perPage=${this.serverParams.perPage}&payment_method=${this.filter.payment_method}&status=${this.filter.status}&user_type=${this.filter.user_type}&start_date=${this.filter.start_date}&end_date=${this.filter.end_date}`;

                let {data: {data: {transactions}}} = await axios.get(url);

                this.totalRecords = transactions.total;
                this.paginationOptions.perPage = transactions.per_page;
                this.allTransactions = transactions.data
            } catch (e) {
                console.log(e);
            }
        },

        async resetFilter() {
            this.filter = {
                payment_method : '',
                    status : '',
                    user_type : '',
                    start_date: '',
                    end_date: ''
            }
            this.searchTerm = ""

            this.paginatedData();
        },

        serialNo(props) {
            return this.serverParams.page === 1 ? props.index + 1 : (this.serverParams.perPage *
                    (this.serverParams.page - 1)) +
                props.index + 1
        },

        formatDateTime(value) {
            if (! value) return value

            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        formatDateShort(value) {
            if (! value) return value

            const date = new Date(value);
            const year = String(date.getFullYear()).slice(-2);
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${day}-${month}-${year} ${hours}:${minutes}`;
        },
        statusClass(value) {
            return value ? "badge-success" : "badge-warning";
        },
        transactionStatus(value) {
            if (value === 'pending') {
                return "warning";
            } else if (value === 'success')
            {
                return "primary";
            } else {
                return "danger";
            }
        },
    }
}
</script>
